var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42308 17.9167C4.00211 17.9167 3.64579 17.7708 3.35413 17.4792C3.06246 17.1875 2.91663 16.8312 2.91663 16.4102V5.25647C2.91663 4.8355 3.06246 4.47918 3.35413 4.18751C3.64579 3.89585 4.00211 3.75001 4.42308 3.75001H5.57683V1.9873H6.85892V3.75001H13.1731V1.9873H14.4231V3.75001H15.5768C15.9978 3.75001 16.3541 3.89585 16.6458 4.18751C16.9375 4.47918 17.0833 4.8355 17.0833 5.25647V16.4102C17.0833 16.8312 16.9375 17.1875 16.6458 17.4792C16.3541 17.7708 15.9978 17.9167 15.5768 17.9167H4.42308ZM4.42308 16.6667H15.5768C15.641 16.6667 15.6998 16.6399 15.7531 16.5865C15.8066 16.5331 15.8333 16.4744 15.8333 16.4102V8.5898H4.16663V16.4102C4.16663 16.4744 4.19336 16.5331 4.24683 16.5865C4.30017 16.6399 4.35892 16.6667 4.42308 16.6667Z",
    fill: "#6929E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCalender);
export default __webpack_public_path__ + "static/media/filterCalender.790113bca8024454b0a008d9895076c9.svg";
export { ForwardRef as ReactComponent };